/**
 * 全局"积分不足"弹窗状态。
 * 由 axios 拦截器在收到 402 时调用 show()，CreditsDialog.vue 渲染。
 */
export const useCreditsDialogStore = defineStore('creditsDialog', () => {
  const visible = ref(false);
  const message = ref('You don\'t have enough credits to continue.');

  function show(msg?: string) {
    if (msg) message.value = msg;
    visible.value = true;
  }
  function close() { visible.value = false; }

  return { visible, message, show, close };
});
